import { getAccessToken } from './api/axios.js';
import { DEMO_TOKEN } from './demo/adapter.js';

/**
 * Google Analytics 4 — басмаканаларга жиберилген шилтемелерди ким ачканын
 * көрүү үчүн.
 *
 * ID `VITE_GA_ID` (G-XXXXXXX) аркылуу берилет — Railway'дин Web сервисине
 * жазылат, билд учурунда кодго кирет. Бош болсо аналитика таптакыр иштебейт.
 *
 * Адамдын атын GA билбейт: «ким» деген — шилтемедеги `utm_source`
 * (`/demos` бетинде ар басмаканага өзүнчө шилтеме түзүлөт). GA аны
 * Reports → Acquisition → Traffic acquisition → Session source деп көрсөтөт.
 *
 * Чыныгы аккаунт менен иштегенде (админ) эч нерсе жиберилбейт — өзүбүздүн
 * иш статистиканы бузбасын, кардардын китептери жөнүндө маалымат чыкпасын.
 */
const GA_ID = import.meta.env.VITE_GA_ID;

const enabled = () => {
  if (!GA_ID || typeof window === 'undefined' || !window.gtag) return false;
  const token = getAccessToken();
  return !token || token === DEMO_TOKEN;
};

export function initAnalytics() {
  if (!GA_ID || typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  // gtag ушундай `arguments` менен иштейт — массив болсо GA окубайт
  window.gtag = function gtag() { window.dataLayer.push(arguments); }; // eslint-disable-line prefer-rest-params
  window.gtag('js', new Date());
  // Барактарды өзүбүз жиберебиз (SPA): GA өзү биринчи бетти гана көрөт
  window.gtag('config', GA_ID, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  document.head.appendChild(script);
}

/** Бет алмашканда. `page_location` толук дарек — utm белгилери ушундан окулат */
export function trackPage() {
  if (!enabled()) return;
  window.gtag('event', 'page_view', {
    page_location: window.location.href,
    page_path: window.location.pathname,
    page_title: document.title,
  });
}

/** Маанилүү аракет: demo_start, upgrade_open, contact_click … */
export function track(name, params = {}) {
  if (!enabled()) return;
  window.gtag('event', name, params);
}
